<template>
	<v-container fluid class="mb-10">
		<v-row>
			<v-col cols="12" sm="6" md="4">
				<v-card outlined class="backgroundTransparent">
					<v-card-text>
						<v-menu v-model="menu" :close-on-content-click="false" max-width="290">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									clearable
									dense
									outlined
									filled
									solo
									label="Seleccione un mes"
									readonly
									v-bind="attrs"
									v-on="on"
									@click:clear="month = null"
									hide-details
									:value="dateFormatted"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="month"
								@change="menu = false"
								no-title
								type="month"
								locale="es"
							></v-date-picker>
						</v-menu>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" v-if="histories.length" class="overflow-y-auto">
				<table class="elevation-1 backgroundTransparent">
					<thead>
						<tr>
							<th style="min-width: max-content !important;">
								Establecimiento
							</th>
							<th class="col-table-history">Et - pr</th>
							<th class="col-table-history">Fecha</th>
							<th class="col-table-history">Ingreso</th>
							<th class="col-table-history">Salida</th>
							<th class="col-table-history">Extra</th>
							<th class="col-table-history">Retraso</th>
							<th class="col-table-history">Duración</th>
							<th class="col-table-history">Ganado</th>
							<th class="col-table-history">Temp</th>
							<th class="col-table-history">Foto</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row-history" v-for="history in histories" :key="history._id">
							<td>
								<div class="row-td-block">
									{{ history.place }}
								</div>
							</td>
							<td>
								<div class="row-td-block">
									{{ history.room }} - {{ history.period }}
								</div>
							</td>
							<td>
								<div class="row-td-block">{{ dateTime(history) }}</div>
							</td>
							<td>
								<div class="row-td-block">
									<span v-if="!history.worked">{{ formatDate(history.in) }}</span>
									<span v-else>-</span>
								</div>
							</td>
							<td>
								<div class="row-td-block">
									<span v-if="!history.worked">
										{{ formatDate(history.out) }}
									</span>
									<span v-else>-</span>
								</div>
							</td>
							<td>
								<div class="row-td-block">
									<span v-if="!history.worked">{{ history.extra }}</span>
									<span v-else>-</span>
								</div>
							</td>
							<td>
								<div class="row-td-block">
									<span v-if="!history.delay">{{ history.delay }}</span>
								</div>
							</td>
							<td>
								<div class="row-td-block">
									<span v-if="!history.worked">{{
										durations(history.in, history.out)
									}}</span>
								</div>
							</td>
							<td>
								<div class="row-td-block">
									<template v-if="history.earned">
										<span>{{ history.earned.toFixed(2) }}</span>
										<span class="success--text"> $ </span>
									</template>
									<span v-else>-</span>
								</div>
							</td>
							<td>
								<div class="row-td-block">
									<span v-if="history.temperature">{{
										history.temperature
									}}</span>
									<span v-else>S/R</span>
								</div>
							</td>
							<td>
								<div class="row-td-block">
									<a
										class="text-capitalize"
										v-if="history.image"
										:href="history.image"
										target="_blank"
									>
										Ver foto
									</a>
									<span v-else>Sin foto</span>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</v-col>
			<v-col v-else cols="12">
				<data-empty
					:title="`Sin registros.`"
					:msj="`Aún no hay registros de ingreso o salida durante este mes`"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			loading: false,
			headers: [
				{ text: 'Establecimiento', value: 'place', sortable: true },
				{ text: 'Fecha', value: 'date', sortable: true },
				{ text: 'Ingreso', value: 'in', sortable: true },
				{ text: 'Temp.', value: 'temperature', sortable: true },
				{ text: 'imagen', value: 'image', sortable: false },
				{ text: 'Salida', value: 'out', sortable: true },
				{ text: 'Horas extra', value: 'extra', sortable: true },
				{ text: 'Horas faltantes', value: 'delay', sortable: true },
				{ text: 'Duración', value: 'durations', sortable: true },
				{ text: 'Ganado', value: 'earned', sortable: true },
			],
			dialog: false,
			position: null,
			search: '',
			itemsPerPage: 30,
			menu: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
		};
	},
	computed: {
		histories() {
			let endDate = moment(this.month);
			const lodgings = this.lodgingsOfPersons;
			let histories = [];
			lodgings.forEach(lodging => {
				let newHistories = [];
				lodging.histories.forEach(history => {
					const historyDate = moment(history.in);
					if (historyDate.isSame(endDate, 'month')) {
						newHistories.push({
							...history,
							place: lodging.place.name,
							room: lodging.room,
						});
					}
				});
				histories = [...histories, ...newHistories];
			});

			histories = histories.sort((a, b) => {
				const da = new Date(a.in).getTime();
				const db = new Date(b.in).getTime();

				return db < da ? -1 : db > da ? 1 : 0;
			});
			return histories;
		},
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		...mapGetters({ lodgingsOfPersons: 'Lodging/lodgingsOfPersons', person: 'Person/person' }),
	},
	mounted() {},
	methods: {
		dateTime(item) {
			return moment(item.in).format('DD-MM-YYYY');
		},
		formatDate(date) {
			if (date) return moment(date).format('LT');
			else return '-';
		},
		durations(start, end) {
			if (end) {
				const diff = moment(end).diff(moment(start));
				return moment.utc(diff).format('HH:mm:ss');
			}
			return '-';
		},
	},
};
</script>
<style scoped>
.col-table-history {
	min-width: 90px !important;
}
.row-td-block {
	width: max-content;
}
table {
	font-size: 12px;
}
tbody td {
	padding-right: 10px;
	padding-left: 10px;
}

tbody tr:nth-child(odd) {
	background-color: #3e419a24;
}
</style>
